import { LAYOUT } from '../constants'

/**
 * @type {import('vue-router').RouteConfig[]}
 */
export default [
  {
    path: '/notice',
    component: LAYOUT,
    redirect: '/notice/announcement',
    meta: { title: '通知公告', hide: true, showNavPanel: true },
    children: [
      {
        path: 'announcement',
        name: '通知公告',
        component: () => import('@/views/notice/announcement.vue'),
        meta: { title: '通知公告', hide: true, showNavPanelBorder: true },
      },
    ],
  },
]
